module.exports = __webpack_public_path__ + "static/media/bubble_13.34555473.jpg";